// Page-specific scripts are loaded as separate Webpack chunks and only fetched when the
// page actually contains the element they operate on, keeping them out of the main bundle.
//
// Each entry needs a selector that is unique to the page(s) the module is for. Modules
// listed here must be safe to run late, i.e. they attach their own behaviour on load and
// nothing else (inline view scripts especially) depends on them being available
// synchronously.
export const PAGE_MODULES = [
  { selector: '.v2-work-page-container', load: () => import('application/pages/work') },
  { selector: '#alternative_availability_form', load: () => import('application/pages/availability/alternative') },
  { selector: '#new_contact', load: () => import('application/pages/contact') },
  { selector: '#payment-options-form', load: () => import('application/pages/billing') },
  { selector: '#authentication-form', load: () => import('application/pages/payment') },
  { selector: '.booking-questions', load: () => import('application/pages/booking-questions') },
  { selector: 'form#heard-about-us-form', load: () => import('application/pages/bookings-complete') },
  // The rebook buttons live in a modal rendered independently of the last-mechanic panel.
  { selector: '.last-mechanic, .js-rebook-mechanic-btn', load: () => import('application/pages/last-mechanic-form') },
  { selector: 'form#new_mechanic_review', load: () => import('application/pages/mechanic-reviews') },
  { selector: 'form#new_fleet_enquiry', load: () => import('application/pages/fleet-servicing') },
  { selector: '#mechanic_application_form', load: () => import('application/pages/mechanic-application') },
  { selector: 'form#mechanic-profile-form', load: () => import('application/pages/mechanic-profile-form') },
  { selector: '.diagnostic-tool-v2', load: () => import('application/pages/diagnostic-tool') },
  { selector: 'form#new_mechanic_referral', load: () => import('application/pages/mechanic-referrals') },
  { selector: 'form#mir_form', load: () => import('application/pages/mir-form') },
  { selector: '.js-mechanic-join-cta', load: () => import('application/pages/mechanic-home') },
  { selector: '#booking_vehicle_drivable_false', load: () => import('application/pages/fulfilment_options') },
  // Only the admin mechanic app guide form uses a rich_text_area.
  { selector: 'trix-editor', load: () => import('application/rich_text_editor') },
];

export function loadPageModules(pageModules) {
  return pageModules
    .filter(({ selector }) => document.querySelector(selector))
    .map(({ selector, load }) =>
      load().catch((error) => {
        console.error(`Failed to load page module for selector ${selector}`, error);
      }),
    );
}

export default function lazyLoadPageModules() {
  return loadPageModules(PAGE_MODULES);
}
